import {format} from 'date-fns';
import {t} from '../../getTranslations';
import {parseDate} from './parseDate';

export function getTicketExpiredText(expired_at?: string | Date) {
  if (
    !expired_at ||
    (typeof expired_at === 'string' && isNaN(new Date(expired_at).getDate()))
  ) {
    return;
  }

  if (expired_at instanceof Date) {
    if (expired_at > new Date()) {
      return t('giftbox_gift_expiry_date', {
        values: {
          value: format(expired_at, t('date_formatter_short_year_time_dot')),
        },
      });
    } else {
      return t('giftbox_gift_period_expiry');
    }
  } else {
    if (new Date(expired_at) > new Date()) {
      return t('giftbox_gift_expiry_date', {
        values: {
          value: format(
            parseDate(expired_at),
            t('date_formatter_short_year_time_dot')
          ),
        },
      });
    } else {
      return t('giftbox_gift_period_expiry');
    }
  }
}
